export default __webpack_public_path__ + "static/donate-cover-246169a18960bf824b71dc964656c9e0.jpg";